// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"167":"detail","443":"about","795":"goods","894":"services"}[chunkId] + "." + {"167":"fc22ae17","443":"9acad45e","795":"f798fe2f","894":"26645d55"}[chunkId] + ".js";
};